import {config} from "../environment";
import {useAsync} from "../utils/utils";

export type OppsigelseFormData = {
  plasseringId: number,
  barnIdent: string,
  sluttDato: string,
  begrunnelseId: string
}

type OppsigelseStatus = 'NY' | 'AKTIV' | 'AVSLÅTT' | 'GODKJENT' | 'UKJENT'

type Oppsigelse = {
  barnIdent: string
  barnFornavn: string
  barnEtternavn: string
  ønsketDato: string
  grunn: string
  barnehageNavn: string
  status: OppsigelseStatus
  merknad: string
}

type OppsigelseRequest = {
  barnIdent: string
  plasseringId: string
  sluttDato: string
  begrunnelseId: number
}

export async function getOppsigelse(id: string) {

  return fetch(`${config.apiUrl}/api/barnehageplass/oppsigelser/${id}`)
  .then(async res => {
    if (!res.ok) {
      throw new Error(`Kunne ikke hente oppsigels: ${res.status} ${res.statusText}`)
    }
    return res
  }).then(r => r.json() as Promise<Oppsigelse>)

}

export async function submitOppsigelse(oppsigelse: OppsigelseFormData) {
  const request: OppsigelseRequest = {
    barnIdent: oppsigelse.barnIdent,
    plasseringId: oppsigelse.plasseringId.toString(),
    sluttDato: oppsigelse.sluttDato,
    begrunnelseId: parseInt(oppsigelse.begrunnelseId),
  }
  return fetch(`${config.apiUrl}/api/barnehageplass/oppsigelser`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(request)
  })
  .then(async res => {
    if (!res.ok) {
      throw new Error(`Kunne ikke sende inn oppsigelse: ${res.status} ${res.statusText}`)
    }
    return res
  })
}


export const useOppsigelse = useAsync(getOppsigelse, false)